export enum ErknmPlanStatusTitlesEnum {
  IN_PROCESS = 'В процессе формирования',
  UNDER_CONSIDERATION = 'На рассмотрении',
  CONSIDERED = 'Рассмотрен',
  APPROVED = 'Утверждён',
}
